import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    padding: theme.spacing(1, 4.5, 0),
  },
  header: {
    width: '100%',
    height: theme.spacing(6),
    marginLeft: theme.spacing(3.125),

    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
    },
  },
  title: {
    textAlign: 'center',
    fontFamily: '"Bebas Neue"',
    fontSize: theme.spacing(5),
    paddingBottom: theme.spacing(0.5),
  },
  subtitle: {
    textAlign: 'center',
    paddingBottom: theme.spacing(2.5),
  },
  actionsContainer: {
    display: 'flex',
    flexDirection: 'initial',
    justifyContent: 'space-evenly',
    width: '100%',
  },
}));
